import { useCallback, useEffect, useState } from "react";

import { ApiResponse } from "../interfaces/paginated";
import { api } from "../services/api";

export function useQuery<T>(endpoint: string) {
    const [data, setData] = useState<T>();
    const [isLoading, setIsLoading] = useState(true);

    const loadData = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await api.get<ApiResponse<T>>(endpoint);
            if (response.data.status) {
                setData(response.data.response);
            }
        } catch (error) {
            console.error(`Erro ao carregar dados de ${endpoint}`, error);
        } finally {
            setIsLoading(false);
        }
    }, [endpoint]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const refresh = () => {
        loadData();
    };

    return { data, isLoading, refresh };
}
